module.exports = __webpack_public_path__ + "static/media/icons-hero-home.f5391507.svg";